import type { Transaction, TransferRequest } from "@/utils/types";
import type { Comment, CommentTarget } from "@aircap/common/comment";

export const isOwnComment = ({ author }: Comment, uid: string | undefined) =>
  author.source === "aircap" && author.uid === uid;

// A transfer request and its transaction share one thread: new messages go to the first target.
export const transactionCommentTargets = ({
  id,
  transferRequest,
}: Pick<Transaction, "id" | "transferRequest">): CommentTarget[] => [
  { targetType: "transaction", targetId: id },
  ...(transferRequest
    ? [{ targetType: "transferRequest" as const, targetId: transferRequest.id }]
    : []),
];

export const transferRequestCommentTargets = ({
  id,
  transactionId,
}: Pick<TransferRequest, "transactionId"> & { id: string }): CommentTarget[] => [
  { targetType: "transferRequest", targetId: id },
  ...(transactionId ? [{ targetType: "transaction" as const, targetId: transactionId }] : []),
];
